import { ApiType } from "@gymflow/common";
import { AppointablePatchDTO } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appointableQueryKeys } from "./appointableQueryKeys";

export function useAppointableEdit({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      patchedFields,
      appointableId,
    }: {
      patchedFields: AppointablePatchDTO;
      appointableId: number;
    }) => {
      return (await api.appointableApi.update(appointableId, patchedFields))
        .data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: appointableQueryKeys.all() });
    },
  });
}
